// @flow
import SlotsDishes, { type SelectedItem } from './SlotsDishes';

export default SlotsDishes;
export type { SelectedItem };
